import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-radio-button:focus {
    box-shadow: none !important;
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 5px 0px 0px 5px;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0px 5px 5px 0px;
  }
  .appoinment-buttons {
    margin-top: 10px;
    .ant-radio-group {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 5px;
    }
  }
  .count-number-col {
    margin-left: 5px;
    width: 100%;
  }

  .search-container {
    margin-bottom: 10px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }
  .search-box {
    border: 1px solid black;
    padding: 3px 15px;
  }
  .search-button:hover {
    border: 2px solid black;
    height: 40px;
  }
  .search-button {
    padding: 18px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search-row {
    display: flex;
    align-items: center;
  }
  .group-button-col {
  }
  .ant-select-selector {
    border: 1px solid #3a96b8 !important;
    background-color: #3a96b8 !important;
  }
  .ant-select-selector .ant-select-selection-placeholder {
    color: white;
  }
  .ant-select-multiple .ant-select-selection-item {
    color: black;
  }
  .ant-select-arrow {
    color: white;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    color: white !important;
  }
  .appoinment-buttons {
    .appoinment-button-three {
    }
  }
  .ant-radio-button-wrapper {
    padding: 5px 15px;
    color: #fff;
    height: 40px;
    background: #3a96b8 !important;
    font-size: 16px;
  }
  .ant-radio-button-wrapper:hover {
    background-color: #fff;
  }
  .ant-radio-button-wrapper-checked {
    background-color: #fff;
    color: #40a9ff;
    z-index: 0;
  }
  .date-header-col {
    padding: 0px;
    p {
      display: flex;
      align-items: center;
    }
  }
  .date-created {
    padding-left: 10px;
    // padding-right: 16px;
  }
  .date-picker {
    border-radius: 4px;
    width: 100%;
  }
  .appoinment-button-three {
  }
  .appoinment-buttons {
    .ant-radio-group {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      /* margin-left: 10px; */
    }
    .ant-radio-button-checked {
      background-color: #fff;
      color: #40a9ff;
    }
  }

  /* .ant-radio-button-wrapper-checked:not {
    z-index: 0;
  } */
  .ant-radio-button:focus {
    box-shadow: none !important;
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 5px 0px 0px 5px;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0px 5px 5px 0px;
  }
  @media only screen and (max-width: 600px) {
    .ant-radio-button-wrapper {
      padding: 5px 15px;
    }
  }
  @media only screen and (max-width: 450px) {
    .ant-radio-button-wrapper {
      padding: 5px 10px;
    }
  }
  /* .appoinment-filter-col {
    padding-left: 5px;
  } */
  .all-filter-col {
    /* padding-left: 15px; */
    display: flex;
    /* justify-content: center; */
  }
  .appoinment-header-col {
    display: flex;
    align-items: center;
    /* padding-left: 15px; */

    p {
      margin: 0px;
      font-size: 15px;
    }
  }

  .ant-picker {
    width: 100%;
  }
  @media only screen and (max-width: 1200px) {
    .all-filter-col {
      display: flex;
      justify-content: flex-start;
      padding-left: 5px;
    }
    .appoinment-filter-col {
      padding-left: 5px;
    }
    #Created-after-date{
      display: flex;
      justify-content: flex-start !important;
    }
  }

  @media screen and (max-width: 1042px) {
    .ant-radio-button-wrapper {
      padding: 5px 22px !important;
    }
  }

  @media screen and (max-width: 700px) {
    .appoinment-buttons {
      .ant-radio-group {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 5px;
      }
      .ant-radio-button {
        display: flex;
        justify-content: center;
        border-radius: 0px !important;
      }
      .ant-radio-button-wrapper:first-child {
        border-radius: 0px 0px 0px 0px;
      }
    }
  }
  @media screen and (max-width: 986px) {
    .ant-radio-button-wrapper {
      padding: 5px 18px !important;
    }
  }
  /* @media screen and (max-width: 746px) {
    .ant-radio-button-wrapper {
      padding: 5px 15px !important;
    }
  } */
`;
